// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"bF_gY","list":"bF_cM","link":"bF_d","title":"bF_l","externalLink":"bF_hy","description":"bF_F","actions":"bF_hk","body":"bF_dV","actionLink":"bF_hz"};